import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { AppBar, Toolbar, Typography, Button, IconButton, MenuItem, List, ListItem, ListItemText, Drawer, ListItemButton, ListItemIcon } from '@mui/material';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { NavLink, Link } from "react-router-dom";
import LOOKUP from "constants/lookup";
import {
  logout,
  openDialogChangePassword,
  changeBranch,
  getStores,
  changeStore,
  handleCheckInDialog
} from "actions/CommonActions";
import { getUserRolePageByName } from "actions/EntityActions";
import Popover from '@mui/material/Popover';
import SupportLandingApp from "../../containers/support/SupportLandingApp";
import DashboardIcon from '@mui/icons-material/Dashboard';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import GradeIcon from '@mui/icons-material/Grade';
import SettingsIcon from '@mui/icons-material/Settings';
import StoreIcon from '@mui/icons-material/Store';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import MenuIcon from '@mui/icons-material/Menu';
import PeopleIcon from '@mui/icons-material/People';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import imgLogo from "images/TECHPOS_NoBG.png"
import 'styles/menu.css';
import UpdateNews from 'images/megaphone.png'
import CheckIn from 'images/checkin.png';
import AIVideoDialog from "../../containers/ai/AIVideoDialog";
import aiVideoButton from "images/AiVideoIcon.png";
import { currentAIVideoVersion } from "../../containers/ai/AIVideoList";
import WithRouter from "custom/withRouter";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import DialogInput from "../advanced/DialogInput";
import CustomButton from "./Button";
import DialogHeader from "./DialogHeader";
import LanguageSwitch from "./LanguageSwitch";

const style = {
  title: {
    cursor: "pointer"
  }
};

class Menu extends Component {
  constructor(props) {
    super(props);
    const storedVersion = localStorage.getItem('aiVideoVersion');
    this.state = {
      open: false,
      branch: null,
      helpTabOpen: false,
      settingsView: false,
      aiVideo: false,
      aiAnimation: storedVersion !== currentAIVideoVersion,
      openPermissionDialog: false
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.handleTitleTouchTap = this.handleTitleTouchTap.bind(this);
    this.handleSettings = this.handleSettings.bind(this);
    this.openChangeBranchDialog = this.openChangeBranchDialog.bind(this);
    this.handleVideoPopOverClose = this.handleVideoPopOverClose.bind(this);
    this.handleClockinOut = this.handleClockinOut.bind(this);
    this.helpTabClick = this.helpTabClick.bind(this);
    this.helpHandleRequestClose = this.helpHandleRequestClose.bind(this);
  }

  componentDidMount() {
    if (this.state.aiAnimation) {
      this.timer = setTimeout(() => {
        this.setState({
          aiAnimation: false
        }, () => {
          localStorage.setItem('aiVideoVersion', currentAIVideoVersion);
        });
      }, 10000);
    }

    const selectedStore = localStorage.getItem('TECHPOS_CompanyCode') || ``;
    this.props.getStores();

    const userRole = this.props.authenticatedUser.roles;
    if (selectedStore && userRole) {
      this.props.getUserRolePageByName(userRole[0]);
    }

    if (this.props.branchId && this.props.authenticatedUser && !this.props.authenticatedUser.claims) {
      this.openPermissionDialog();
    }
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.branches &&
      newProps.branches.length > 0 &&
      newProps.branchId &&
      this.state.branch === null
    ) {
      this.setSelectedBranch(newProps.branches, newProps.branchId);
    }

    if (newProps.isUserAuthenticated === false || newProps.branchId === null) {
      this.setState({ branch: null });
    }

    if (
      newProps.branches &&
      this.props.branchId !== newProps.branchId &&
      newProps.branchId > 0
    ) {
      this.setSelectedBranch(newProps.branches, newProps.branchId);
    }

    if (newProps.branchId && newProps.branchId != this.props.branchId && newProps.authenticatedUser && !newProps.authenticatedUser.claims) {
      this.openPermissionDialog();
    }
  };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  openPermissionDialog = () => {
    this.setState({ openPermissionDialog: true });
  }

  closePermissionDialog = () => {
    this.setState({ openPermissionDialog: false });
  }

  setSelectedBranch = (branches, id) => {
    const branch = branches.find(branch => branch.id === +id);
    this.setState({ branch });
  };

  handleToggle() {
    this.setState({ open: !this.state.open });
  }

  handleTitleTouchTap() {
    this.props.navigate("/");
  }

  openChangePasswordDialog = () => {
    this.setState({ settingsView: false })
    this.props.openDialogChangePassword();
  };

  openChangeBranchDialog = () => {
    this.props.changeBranch();
    this.setState({ settingsView: false })
    this.props.navigate("/");
  };

  handleSettings = () => {
    let screen = document.querySelector('.dropDownWrapper')
    this.setState({ settingsView: !this.state.settingsView });

    document.addEventListener('click', (e) => {
      (screen != e.target && screen.contains(e.target)) ? (this.setState({ settingsView: false })) : ''
    });
  }

  handleClockinOut = () => {
    this.setState({ settingsView: false })
    this.props.navigate("/clock-in")

  }

  handleCheckInDialog = () => {
    this.props.handleCheckInDialog();
  }

  handleSchedule = () => {
    this.setState({ settingsView: false })
    this.props.navigate("/my-schedule")
  }

  handleChangeStore = () => {
    this.props.changeStore();
    this.setState({ settingsView: false })
    this.props.navigate("/storeList")
  }

  logout = () => {
    this.props.logout();
    caches.keys().then(function (keyList) {
      return Promise.all(keyList.map(function (key) {
        return caches.delete(key);
      }));
    })
    window.location.href = "/";
  };

  getIcon(props) {
    switch (props) {
      case "Dashboard":
        return <DashboardIcon />;

      case "POS Sales":
        return <StoreIcon className="menuIconSvg" />;

      case "Inventory":
        return <PlaylistAddCheckIcon className="menuIconSvg" />;

      case "Vendor":
        return <GradeIcon className="menuIconSvg" />

      case "Admin":
        return <VerifiedUserIcon className="menuIconSvg" />;

      case "Vendor":
        return <LibraryBooksIcon className="menuIconSvg" />;

      case "Users":
        return <PeopleIcon className="menuIconSvg" />;

      case "Reports":
        return <TrendingUpIcon className="menuIconSvg" />;

      case "Pricing":
        return <MonetizationOnIcon className="menuIconSvg" />;

      case "Preferences":
        return <SettingsIcon className="menuIconSvg" />;

      case "Web Menu":
        return <MenuIcon className="menuIconSvg" />;

      case "Video Support":
        return <SlideshowIcon className="menuIconSvg" />;

      case "Compliance Report":
        return <LibraryBooksIcon className="menuIconSvg" />;

      default:
        return <GradeIcon className="menuIconSvg" />;
    }
  }

  createListItem = item => {
    let id = item.pageId;
    const isOwner = this.props.authenticatedUser && this.props.authenticatedUser.roles.includes("StoreOwner") ? true : false;


    let childs = [];
    // has child

    if (item.items) {
      childs = item.items
        .map((childItem) => {
          const childId = `${childItem.text.replace(/ /g, "_")}_${childItem.pageId}`;
          const isUserList =
            childItem.text === 'User Role' || childItem.component === 'UserRoleList' || childItem.link === '/userrole';

          if (!this.isAuthorized(childItem.pageId) || (!isOwner && isUserList)) {
            return null;
          }

          if (!this.props.isMedical && childItem.text === 'Doctor') {
            return null;
          }

          if (!this.props.memberEnabled && childItem.text === 'Member') {
            return null;
          }

          return (
            <ListItem
              key={childId}
              component={NavLink}
              to={childItem.link || '#'}
              onClick={this.handleToggle}
              target={item.text === 'Support Hub' ? '_blank' : ''}
            >
              <ListItemText primary={childItem.text} />
            </ListItem>
          );
        })
        .filter(Boolean);
    }

    if (item.link && this.isAuthorized(id)) {
      return (
        <ListItem key={item.link} component={Link} to={item.link} onClick={this.handleToggle}>
          <ListItemIcon>{this.getIcon(item.text)}</ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItem>
      );
    }

    if (childs.length > 0) {
      const NestedMenuItemId = `${item.text.replace(/ /g, "_")}`;
      // console.log(NestedMenuItemId, childs)
      return <NestedMenuItem key={NestedMenuItemId} item={item} childs={childs} getIcon={this.getIcon} />;
    }

    return null;
  };

  isAuthorized = id => {
    if (this.props.userRolePage && this.props.userRolePage.access && this.props.userRolePage.access.length === 0 && this.props.authenticatedUser && this.props.authenticatedUser.roles.includes("StoreOwner")) return true;
    return this.props.userRolePage &&
      this.props.userRolePage.access &&
      this.props.userRolePage.access[id] &&
      this.props.userRolePage.access[id].hasAccess;
  };

  // Help Tab Click
  helpTabClick(e) {
    this.setState({
      helpTabOpen: true,
      anchorEl: e.target
    });
  };

  // Help Tab Request Close
  helpHandleRequestClose() {
    this.setState({
      helpTabOpen: false
    });
  };

  filterMenu(hasWebMenu, menuData) {
    if (!hasWebMenu) {
      return menuData.filter(obj => obj.text !== 'Web Menu');
    }
    return menuData;
  };

  handleVideoPopOver(e) {
    e.preventDefault();
    this.setState({
      aiVideo: true
    });
  };

  handleVideoPopOverClose() {
    this.setState({
      aiVideo: false
    });
  };



  render() {
    const menu = this.filterMenu(this.props.hasWebMenu, LOOKUP.menuData);

    const stores = this.props.stores && this.props.stores.length > 1;

    // const adminAccess = this.props.authenticatedUser && this.props.authenticatedUser.roles.includes("StoreOwner") ? true : false;

    const menuGov = LOOKUP.menuGov;
    let p = this.props;

    const logged = (
      <MenuIcon
        iconButtonElement={
          <IconButton className="pl-2 pr-2 dsp-nn" style={{ margin: "0px !important" }}>
            <MoreVertIcon className="icon-button-db" />
          </IconButton>
        }
        targetOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {p.isUserAuthenticated &&
          p.branches &&
          p.branches.length > 0 ? (
          <MenuItem
            primaryText="Change Branch"
            onClick={() => this.openChangeBranchDialog()}
          />
        ) : null}
        <MenuItem
          primaryText="My Schedule"
          onClick={() => this.props.navigate("/my-schedule")}
        />
        <MenuItem
          primaryText="Change Store"
          onTouchTap={() => this.props.navigate("/storeList")}
        />
        <MenuItem
          primaryText="Change Password"
          onClick={() => this.openChangePasswordDialog()}
        />
        <MenuItem primaryText="Sign out" onClick={() => this.logout()} />
      </MenuIcon>
    );

    return (
      <React.Fragment>
        <AppBar position="fixed" >
          <Toolbar>

            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              <div>
                <div
                  style={style.title}
                  className="menu_logo"
                  onClick={this.handleTitleTouchTap}
                ></div>
                <div className="storeInfo">
                  <div className="pull-right menu_branch divAlignNavBar">
                    <svg version="1.1" id="Layer_1" x="0px" y="0px" className="menuHamNavBar" viewBox="0 0 40 40" onClick={() => this.handleToggle()}>
                      <g>
                        <rect x="1" y="7" className="hamburguerMenuColor" width="38" height="4.13" />
                        <rect x="1" y="17.94" className="hamburguerMenuColor" width="38" height="4.13" />
                        <rect x="1" y="28.87" className="hamburguerMenuColor" width="38" height="4.13" />
                      </g>
                    </svg>
                    {this.props.userPin && this.props.userPin.authenticated
                      ? <span className="txtWhiteFont">{this.props.userPin.employee.name + " "}</span>
                      :
                      this.props.authenticatedUser
                        ? <span className="txtWhiteFont font-18px">{this.props.authenticatedUser.firstName + " "}</span>
                        : ""}
                    {this.state.branch && this.props.isUserAuthenticated
                      ? <span
                        title={this.state.branch.name}
                        className="green-text font-14px pl-2 classicUIWhiteColor header-branch-name-context">{"(" + this.state.branch.name + ")"}</span>
                      : ""}
                    {this.state.branch && this.props.isUserAuthenticated ? (
                      <div className="pull-right menu_branch branch_name">
                        - {this.state.branch.provinceState}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="d-flx justify-content-center">
                    <img src={imgLogo} alt="Techpos Logo" className="techposLogoBar" onClick={() => this.props.navigate("/")} />
                  </div>

                  <div className="dsp-flx-barIcon">
                    <span id='BuddiB2B' className={this.state.buddib2b ? "barIconBranch icon-container" : "barIconBranch"} style={{ width: "80px", height: "50px" }}>
                    </span>
                    <span className={this.state.aiAnimation ? "barIconBranch icon-container" : "barIconBranch"} style={{ width: "55px", height: "50px" }} onClick={(e) => this.handleVideoPopOver(e)}>
                      <img className={this.state.aiAnimation ? "icon" : ""} src={aiVideoButton} alt="Techpos Logo" style={{ width: "42px", height: "42px" }} />
                    </span>
                    <AIVideoDialog open={this.state.aiVideo} onClose={this.handleVideoPopOverClose} />
                    <span className="newsBgImg d-flx">
                      <a href="/newfeatures" target="_blank">
                        <img src={UpdateNews} alt="New Updates" className="newsIconHeader" title="New Updates" />
                      </a>
                    </span>
                    {
                      this.props.posMemberCheckInEnabled &&
                      <span className="newsBgImg d-flx" onClick={this.handleCheckInDialog}>
                        <img src={CheckIn} alt="Check In" className="newsIconHeader" title="Check In" />
                      </span>
                    }
                    <span className="barIconClockIn" onClick={this.handleClockinOut}>
                      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className="clockInOutEmp">
                        <title>Clock In/Clock Out</title>
                        <path className="st0" d="M20,4c8.82,0,16,7.18,16,16s-7.18,16-16,16S4,28.82,4,20S11.18,4,20,4 M20,2C10.06,2,2,10.06,2,20 s8.06,18,18,18s18-8.06,18-18S29.94,2,20,2L20,2z" />
                        <polygon className="st0" points="24.02,27.5 17.84,21.32 17.84,9.2 20.72,9.2 20.72,20.12 26.06,25.46" />
                      </svg>
                    </span>
                    <span id="menuChangeBranch" className="barIconBranch" onClick={this.openChangeBranchDialog}>
                      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className="clockInOutEmp">
                        <title>Branch Selection</title>
                        <path className="st0" d="M36,34V15.79c0.47-0.48,0.82-1.09,0.94-1.79H37v-4l-5-7H20H8l-5,7v4c0,0,0.06,0,0.06,0
                    c0.12,0.69,0.47,1.31,0.94,1.79V34H2v3h36v-3H36z M6,16.76c0.13,0.02,0.26,0.04,0.4,0.04c1.3,0,2.41-0.73,2.98-1.8h0.83
                    c0.57,1.07,1.69,1.8,2.98,1.8s2.41-0.73,2.98-1.8h0.83c0.57,1.07,1.69,1.8,2.98,1.8s2.41-0.73,2.98-1.8h0.83
                    c0.57,1.07,1.69,1.8,2.98,1.8s2.41-0.73,2.98-1.8h0.83c0.57,1.07,1.69,1.8,2.98,1.8c0.14,0,0.27-0.02,0.4-0.04V34H19V20H8.5v14H6
                    V16.76z M18,34H9.5V21H18V34z"/>
                        <path className="st0" d="M32,22H22v7h10V22z M31,28h-8v-5h8V28z" />
                      </svg>
                    </span>
                    <span className="barIconSettings" onClick={this.handleSettings}>
                      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className="clockInOutEmp">
                        <title>Settings</title>
                        <path className="st0" d="M20,10.5c-5.24,0-9.5,4.26-9.5,9.5s4.26,9.5,9.5,9.5s9.5-4.26,9.5-9.5S25.24,10.5,20,10.5z M20,28 c-4.42,0-8-3.58-8-8s3.58-8,8-8s8,3.58,8,8S24.42,28,20,28z" />
                        <path className="st0" d="M37,22.03l0.01-4l-3.16-0.01c-0.16-1.11-0.44-2.19-0.85-3.2l2.73-1.57l-2-3.47L31,11.36
                    c-0.69-0.87-1.47-1.66-2.34-2.34l1.58-2.73l-3.46-2L25.2,7.01C24.19,6.6,23.11,6.32,22,6.16V3h-4v3.16
                    c-1.08,0.16-2.13,0.43-3.11,0.82l-1.56-2.74L9.85,6.22l1.56,2.74c-0.87,0.68-1.67,1.46-2.36,2.33L6.33,9.69l-2.02,3.45l2.72,1.59
                    c-0.41,1.01-0.7,2.08-0.86,3.2l-3.16-0.02l-0.02,4l3.16,0.02c0.15,1.12,0.44,2.19,0.84,3.2L4.25,26.7l1.99,3.47l2.74-1.57
                    c0.68,0.87,1.46,1.66,2.33,2.35l-1.59,2.72l3.46,2.01l1.58-2.72c1.01,0.41,2.08,0.7,3.2,0.86l-0.01,3.16l0.05,0V37h1.97l1.97,0.01
                    V37H22v-3.16c1.1-0.16,2.16-0.44,3.16-0.83l1.57,2.73l3.47-1.99l-1.57-2.74c0.87-0.68,1.66-1.47,2.35-2.33l2.73,1.58l2.01-3.46
                    l-2.72-1.58c0.41-1.01,0.69-2.08,0.85-3.2L37,22.03z M20,30.5c-5.79,0-10.5-4.71-10.5-10.5c0-5.79,4.71-10.5,10.5-10.5
                    c5.79,0,10.5,4.71,10.5,10.5C30.5,25.79,25.79,30.5,20,30.5z"/>
                      </svg>
                    </span>
                    {this.state.settingsView ?
                      <div className="dropdownMenuStyle tp-50">
                        <ul className="selectWeekList dropdownWhiteBg">
                          <li className="dropdownHoverStyle" onClick={() => this.openChangePasswordDialog()}>Change Password</li>
                          <li className="dropdownHoverStyle" onClick={() => this.handleSchedule()}>My Schedule</li>
                          {stores && <li className="dropdownHoverStyle" onClick={() => this.handleChangeStore()}>Change Store</li>}
                          {/* <li className="dropdownHoverStyle">
                            <LanguageSwitch/>
                          </li> */}
                          <li className="dropdownHoverStyle" onClick={() => this.logout()}>Sign Out</li>
                        </ul>
                      </div>
                      : ""}
                  </div>
                </div>
              </div>
            </Typography>
          </Toolbar>
        </AppBar>
        <div
          className="help-global-tab text-center helpGloabTabHide"
          onClick={this.helpTabClick}
        >
          <span>Help</span>
        </div>
        <Popover
          style={{ zIndex: "9999" }}
          open={this.state.helpTabOpen}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          onClose={this.helpHandleRequestClose}
        >
          <SupportLandingApp />
        </Popover>

        <Drawer
          style={{ zIndex: "9999", width: '350px' }}
          anchor="left"
          width={350}
          open={this.state.open}
          onClose={open => this.setState({ open: false })}
        >
          <div className="menu_container">
            <div className="dashMenuIcon bgGradMenuDash">
              <svg version="1.1" id="Layer_1" className="menuImages" x="0px" y="0px" viewBox="0 0 40 40">
                <path className="homeIconColor" d="M37.82,19.05L20.27,4.31c-0.16-0.14-0.38-0.14-0.55,0L2.18,19.05c-0.34,0.29-0.16,0.9,0.27,0.9h3.4v15.87h10.05
                V24.03h8.62v11.79h10.05V19.95h2.97C37.98,19.95,38.16,19.34,37.82,19.05z"/>
              </svg>
              <h3 id="menu_biz" className="dashboardMenuColor pl-2">Dashboard</h3>
            </div>
            <List style={{ zIndex: "9999" }} className="menuTitleItem p-0 classicMenuTitleItem">
              {this.props.authenticatedUser && menu.length > 0 && menu.map(this.createListItem)}
            </List>
          </div>
          {
            this.props.isVape ? null : (
              <div className="gov_tab">
                <h2 id="menu_gov">Government</h2>
                <List style={{ zIndex: "9999" }} className="menuTitleItem classicMenuTitleItem menuItemGovSpace">
                  {this.props.authenticatedUser && (
                    (this.props.canViewComplianceReport) ? (
                      <div>
                        {/* <ListItem
                          key="ComplianceReport"
                          containerElement={<Link to="/compliances" />}
                          onClick={this.handleToggle}
                          primaryText="Compliance Report"
                          leftIcon={this.getIcon("Compliance Report")}
                        /> */}
                        <ListItem
                          key="ComplianceReport"
                          component={Link}
                          to={"/compliances"}
                          onClick={this.handleToggle}

                        >
                          <ListItemIcon>
                            {this.getIcon("Compliance Report")}
                          </ListItemIcon>
                          <ListItemText primary={"Compliance Report"} />
                        </ListItem>
                      </div>
                    ) : (
                      menuGov.map(this.createListItem)
                    )
                  )}
                </List>
              </div>
            )
          }

        </Drawer>

        <DialogInput
          title={<DialogHeader text="LOGOUT REQUEST" classicClass="posDialogClassic" />}
          open={this.state.openPermissionDialog}
          autoScrollBodyContent={true}
          handleClose={this.closePermissionDialog}
          actions={[<CustomButton
            key={2}
            label="Logout"
            primary={true}
            onTouchTap={this.logout}
          />]}
        >
          New features have been updated. Please log out and log in again.
        </DialogInput>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isUserAuthenticated:
      state.common.isUserAuthenticated == undefined
        ? false
        : state.common.isUserAuthenticated,
    authenticatedUser: state.common.authenticatedUser,
    stores: state.common.storesList,
    branchId: state.common.branchId,
    branches: state.common.userBranches,
    userPin: JSON.parse(sessionStorage.getItem("pinUser"))
      ? JSON.parse(sessionStorage.getItem("pinUser"))
      : state.entity.pin,
    checkinList: state.entity.checkinList,
    isMedical: state.common.applicationSettings.isMedical,
    hasWebMenu: state.common.applicationSettings.hasWebMenu,
    memberEnabled: state.common.applicationSettings.memberEnabled,
    posMemberCheckInEnabled: state.common.applicationSettings.posMemberCheckInEnabled,
    buddiEnabled: state.common.applicationSettings.buddiEnabled,
    userRolePage: state.entity.userRolePage,
    isVape: state.common.applicationSettings.isVape,
    province: state.common.store.provinceState,
    canViewComplianceReport: state.common.authenticatedUser && state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanViewComplianceReport"))
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout()),
    openDialogChangePassword: () => dispatch(openDialogChangePassword()),
    changeBranch: () => dispatch(changeBranch()),
    changeStore: () => dispatch(changeStore()),
    handleCheckInDialog: () => dispatch(handleCheckInDialog()),
    getUserRolePageByName: (roleName) => dispatch(getUserRolePageByName(roleName)),
    getStores: () => dispatch(getStores())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Menu));


function NestedMenuItem({ item, childs, getIcon }) {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <React.Fragment>
      <ListItem onClick={handleToggle} component={item.link ? NavLink : 'div'} to={item.link || '#'}>
        <ListItemIcon>{getIcon(item.text)}</ListItemIcon>
        <ListItemText primary={item.text} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {childs}
        </List>
      </Collapse>
    </React.Fragment>
  );
}